
import './App.css';
import React, { useCallback, useRef, useState } from 'react';
import { toPng } from 'html-to-image';
import { Decreto } from './Components/Decreto';
import PanelFormulario from './Components/PanelFormulario';
import { Typography, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';

const App = () => {
  const classes = useStyles();
  const [formState, setFormState] = useState({
    title:'Título de tu decreto',
    description:'Descripción de tu decreto',
    signature:'tu firma / nombre'
  })
  const ref = useRef(null)

  const onButtonClick = useCallback(() => {
    if (ref.current === null) {
      return
    }

    toPng(ref.current, { cacheBust: true, width:1000, height:1500})
      .then((dataUrl) => {
        const link = document.createElement('a')
        link.download = 'my-image-name.png'
        link.href = dataUrl
        link.click()
      })
      .catch((err) => {
        console.log(err)
      })
  }, [ref])


  const handleChange = (e)=>{
    const key = e.target.name;
    const value = e.target.value;
    console.log(value);
    setFormState({...formState, [key]:value});
  }

  const handleClick = (e) =>{
    const key = e.target.name;
    const value = e.target.value;
    if(value === 'Descripción de tu decreto' || value === 'Título de tu decreto' || value === 'tu firma / nombre'){
      setFormState({...formState, [key]:''});
    }
}

  return (
    <div className="App">
      <Box className={classes.contenedorDecreto} ref={ref}>
        <Decreto formState={formState}/>
      </Box>
      <PanelFormulario formState={formState} onButtonClick={onButtonClick} handleChange={handleChange} handleClick={handleClick} />
      <div className={classes.control}>
        <a className={classes.botonVolver} href="/constitucion-colombia-ninas-ninos/mi-pais">Volver</a>
      </div> 
    </div>
       
  );
}

const useStyles = makeStyles((theme)=>({
  contenedorDecreto:{
    paddingBottom:'20px'
  },
  botonVolver:{
    textAlign: 'center',
    display: 'block',
    fontSize: '15px',
    color:'#fff',
    background:'#C10984',
    padding:'10px 70px',
    borderRadius: '80px',
    textRecoration: 'none',
    maxWidth:'100px',
    margin:'0px auto',
    textDecoration: 'none',
    fontWeight:'bold',
    '&:hover':{
      background:'#A4004B'
    }
  }
}));

export default App;

